import {ServerAlertRuleSeverity} from '../model/ServerAlertRule/IServerAlertRule';
import {ServerIncidentsSeverity, ServerStatus} from '../model/Server/IServer';

import {SERVER_METRICS_UPTIME_MAX_DRIFT_SECONDS} from './serverMetrics';

export type ServerModalType =
    'edit' | 'tags' | 'delete' | 'pause' | 'resume' | 'setToken' | 'regenerate' | 'limit' | null;

export interface IServerRowIconState {
    isPaused: boolean,
    ok: boolean | null,
}

export const getServerRowSeverity = (severity: ServerIncidentsSeverity): ServerAlertRuleSeverity | null => (
    severity === 'none' ? null : severity
);

export const getServerRowIconState = (status: ServerStatus): IServerRowIconState => {
    switch (status) {
        case 'online':
            return {isPaused: false, ok: true};
        case 'offline':
            return {isPaused: false, ok: false};
        case 'paused':
        case 'suspended':
            return {isPaused: true, ok: null};
        default:
            return {isPaused: false, ok: null};
    }
};

export const getServerUptimeElapsedSeconds = (
    isLive: boolean,
    metricsTs: number | null,
    nowSeconds: number,
): number => {
    const drift = isLive && metricsTs ? nowSeconds - metricsTs : 0;

    return Math.min(Math.max(drift, 0), SERVER_METRICS_UPTIME_MAX_DRIFT_SECONDS);
};

export const getServerUptimeSeconds = (
    uptimeSeconds: number | null,
    isLive: boolean,
    metricsTs: number | null,
    nowSeconds: number,
): number | null => {
    if (uptimeSeconds === null) {
        return null;
    }

    return uptimeSeconds + getServerUptimeElapsedSeconds(isLive, metricsTs, nowSeconds);
};
